import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	type CHECKBOX_GQL_FIELD,
	MULTI_CHECKBOXES_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { AggTransformerFunction } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

export const transformAggCheckboxToLegacyField: AggTransformerFunction<
	typeof CHECKBOX_GQL_FIELD
> = (node) => {
	switch (node.type) {
		case MULTI_CHECKBOXES_CF_TYPE: {
			// We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
			const value = transformAggConnection(node.selectedOptions, (option) => ({
				id: option.optionId,
				value: option.value ?? null,
				ari: option.id,
			}));

			const allowedValues = transformAggConnection(node.checkboxesFieldOptions, (option) => ({
				id: option.optionId,
				value: option.value ?? null,
				ari: option.id,
			}));

			return {
				...transformAggNodeToLegacyField(node),
				value: value.length ? value : null,
				allowedValues,
				schema: {
					type: 'array',
					renderer: PLAIN_TEXT,
					custom: node.type,
					system: null,
					items: 'option',
					configuration: null,
				},
			};
		}
		default:
			return undefined;
	}
};
